import * as types from '../mutation-types'
import * as api from '../api'
import moment from 'moment'

const state = {
  chat_messages: []
}

const getters = {
  getChatMessages: state => state.chat_messages,
}

const actions = {
  getChatMessages ({ commit }) {
    api.instance.get('chat_history')
      .then(function (response) {
        const chat_history = response.data.messages
        // change the timestamp field in each element
        chat_history.forEach(function (message) {
          message.timestamp = moment(message.timestamp * 1000).format('h:mm a')
        })

        commit(types.CHAT_HISTORY, chat_history)
      })
      .catch(function (error) {
        console.log(error)
      })
  }
}

const mutations = {
  [types.CHAT_HISTORY] (state, chat_history) {
    state.chat_messages = chat_history
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
